module.exports = __webpack_public_path__ + "static/img/1_1_2.dd0133c2.jpg";